import { User } from '../../_models';
import { BreadcrumbService } from './../../_services/breadcrumb.service';
import { Component, OnInit, } from '@angular/core';
import { AuthenticationService, MenuService } from '../../_services';

@Component({
  selector: 'app-forbidden',
  templateUrl: './forbidden.component.html',
  styleUrls: ['./forbidden.component.scss']
})
export class ForbiddenComponent implements OnInit {
   user: User | undefined;

  constructor(
    private breadServ: BreadcrumbService,
    private menuServ: MenuService,
    private authService: AuthenticationService
  ) { }

  ngOnInit() {
    const user = this.authService.currentUserValue;
    this.user = user;
    this.breadServ.setCurrent({
      header: 'Sem acesso a essa paǵina',
      description: 'Caso seja necessário o acesso à paǵina entre em contanto com o administrador',
      display: true,
      levels: [
        {
          icon: 'dashboard',
          link: ['/'],
          title: 'Home'
        }
      ]
    });
  }
}
